import 'rxjs/add/operator/debounceTime';
import {Component, ViewChild} from '@angular/core';
import {
    Content,
    NavController,
    NavParams,
    Slides,
    ViewController
} from 'ionic-angular';

import {CONFIG} from '../../../app/config';
import {
    TChooseType,
    TFieldType,
    TFileTipo,
    TFileType,
    TGoogleAnalytic,
    TStatusBar,
    Util
} from "../../../app/util";

import {LogadoService} from '../../../providers/logado-service';
import {DomSanitizer} from "@angular/platform-browser";
import {Observable} from "rxjs";
import {TAction, TUpperLowerCase, TZiptipo, TImageModel} from "../../../app/enum";
import {WebstorService} from "../../../providers/webstor-service";

@Component({
    selector: 'page-modal-field',
    templateUrl: 'modal-field.html',
    providers: [WebstorService]
})
export class ModalFieldPage {

    TFileTipo: any = TFileTipo;
    TFileType: any = TFileType;
    TFieldType: any = TFieldType;
    TImageModel: any = TImageModel;

    config: any;
    logado: any;
    perfil: any;

    colorBack: string;

    animecss: any;

    infos: any;
    change: any;
    etapa: number = 1;

    corrigindo: boolean = false;

    fieldObject: any = null;
    fieldSelect: number = 0;
    groupSelect: number = 0;
    itensSelect: number = 0;

    modalinfo: any = {
        documento: '',
        titulo: 'Pesquisa'
    };

    @ViewChild(Content) content: Content;
    @ViewChild(Slides) slider: Slides;

    constructor(public navCtrl: NavController, public navParams: NavParams,
                public sanitizer: DomSanitizer,
                public util: Util, public viewCtrl: ViewController,
                public logadoService: LogadoService, public webstorService: WebstorService) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();

        this.colorBack = 'CorRoxa';

        this.infos = this.navParams.data;
        this.change = this.navParams.data;//this.util.deepCopy(this.infos);

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Modal Field', '/modal-field');

        /* DEFAULT */
        if (this.change.window == 'Animate') this.animate();

        this.start();

        //this.debugTest();

    }

    ionViewDidLoad() {

        this.sliderMove();

    }

    ionViewWilEnter() {


    }

    ionViewDidEnter() {

        //Debug, ao carregar manda para ultima pagina (resumo)
        //this.slider.slideTo(this.infos.slides.length, 0);

        this.slider.slideTo(0, 0);
        this.slider.lockSwipes(true);

        // CALENDAR0BUG-SCREEN: usado para resolver problema do calendário que altera de tamanho antes do ionViewDidEnter
        if (this.infos.slides.length > 1) {

            setTimeout(() => {
                this.slider.slideTo(0, 0);
                this.slider.slideTo(this.infos.slides.length, 0);
                this.slider.lockSwipes(true);
            });

        }

    }

    animate() {

        let arreySeek = [this.config.modalSheet('Bounce', 'bounce'),
            this.config.modalSheet('Flash', 'flash'),
            this.config.modalSheet('Pulse', 'pulse'),
            this.config.modalSheet('RubberBand', 'rubberBand'),
            this.config.modalSheet('Shake', 'shake'),
            this.config.modalSheet('Swing', 'swing'),
            this.config.modalSheet('Tada', 'tada'),
            this.config.modalSheet('Wobble', 'wobble'),
            this.config.modalSheet('Jello', 'jello'),
            this.config.modalSheet('HeartBeat', 'heartBeat')];

        let arreyBoin = [this.config.modalSheet('In', 'bounceIn'),
            this.config.modalSheet('InDown', 'bounceInDown'),
            this.config.modalSheet('InLeft', 'bounceInLeft'),
            this.config.modalSheet('InRight', 'bounceInRight'),
            this.config.modalSheet('InUp', 'bounceInUp'),
            this.config.modalSheet('Out', 'bounceOut'),
            this.config.modalSheet('OutDown', 'bounceOutDown'),
            this.config.modalSheet('OutLeft', 'bounceOutLeft'),
            this.config.modalSheet('OutRight', 'bounceOutRight'),
            this.config.modalSheet('OutUp', 'bounceOutUp')];

        let arreyFain = [this.config.modalSheet('In', 'fadeIn'),
            this.config.modalSheet('InDown', 'fadeInDown'),
            this.config.modalSheet('InDownBig', 'fadeInDownBig'),
            this.config.modalSheet('InLeft', 'fadeInLeft'),
            this.config.modalSheet('InLeftBig', 'fadeInLeftBig'),
            this.config.modalSheet('InRight', 'fadeInRight'),
            this.config.modalSheet('InRightBig', 'fadeInRightBig'),
            this.config.modalSheet('InUp', 'fadeInUp'),
            this.config.modalSheet('InUpBig', 'fadeInUpBig'),

            this.config.modalSheet('Out', 'fadeOut'),
            this.config.modalSheet('OutDown', 'fadeOutDown'),
            this.config.modalSheet('OutDownBig', 'fadeOutDownBig'),
            this.config.modalSheet('OutLeft', 'fadeOutLeft'),
            this.config.modalSheet('OutLeftBig', 'fadeOutLeftBig'),
            this.config.modalSheet('OutRight', 'fadeOutRight'),
            this.config.modalSheet('OutRightBig', 'fadeOutRightBig'),
            this.config.modalSheet('OutUp', 'fadeOutUp'),
            this.config.modalSheet('OutUpBig', 'fadeOutUpBig')];

        let arreyFlip = [this.config.modalSheet('flip', 'flip'),
            this.config.modalSheet('flipInX', 'flipInX'),
            this.config.modalSheet('flipInY', 'flipInY'),
            this.config.modalSheet('flipOutX', 'flipOutX'),
            this.config.modalSheet('flipOutY', 'flipOutY')];

        let arreyLigh = [this.config.modalSheet('In', 'lightSpeedIn'),
            this.config.modalSheet('Out', 'lightSpeedOut')];

        let arreyRoin = [this.config.modalSheet('In', 'rotateIn'),
            this.config.modalSheet('InDownLeft', 'rotateInDownLeft'),
            this.config.modalSheet('InDownRight', 'rotateInDownRight'),
            this.config.modalSheet('InUpLeft', 'rotateInUpLeft'),
            this.config.modalSheet('InUpRight', 'rotateInUpRight'),
            this.config.modalSheet('Out', 'rotateOut'),
            this.config.modalSheet('OutDownLeft', 'rotateOutDownLeft'),
            this.config.modalSheet('OutDownRight', 'rotateOutDownRight'),
            this.config.modalSheet('OutUpLeft', 'rotateOutUpLeft'),
            this.config.modalSheet('OutUpRight', 'rotateOutUpRight')];

        let arreySlin = [this.config.modalSheet('InUp', 'slideInUp'),
            this.config.modalSheet('InDown', 'slideInDown'),
            this.config.modalSheet('InLeft', 'slideInLeft'),
            this.config.modalSheet('InRight', 'slideInRight'),
            this.config.modalSheet('OutUp', 'slideOutUp'),
            this.config.modalSheet('OutDown', 'slideOutDown'),
            this.config.modalSheet('OutLeft', 'slideOutLeft'),
            this.config.modalSheet('OutRight', 'slideOutRight')];

        let arreyZoin = [this.config.modalSheet('In', 'zoomIn'),
            this.config.modalSheet('InDown', 'zoomInDown'),
            this.config.modalSheet('InLeft', 'zoomInLeft'),
            this.config.modalSheet('InRight', 'zoomInRight'),
            this.config.modalSheet('InUp', 'zoomInUp'),
            this.config.modalSheet('Out', 'zoomOut'),
            this.config.modalSheet('OutDown', 'zoomOutDown'),
            this.config.modalSheet('OutLeft', 'zoomOutLeft'),
            this.config.modalSheet('OutRight', 'zoomOutRight'),
            this.config.modalSheet('OutUp', 'zoomOutUp')];

        let arreySpec = [this.config.modalSheet('Hinge', 'hinge'),
            this.config.modalSheet('JackInTheBox', 'jackInTheBox'),
            this.config.modalSheet('RollIn', 'rollIn'),
            this.config.modalSheet('RollOut', 'rollOut')];



        /** SLIDE 01 - A **/
        let arreyAnim = ['Attention', 'Bounce', 'Fade', 'Flip', 'LightSpeed', 'Rotate', 'Slide', 'Zoom', 'Special'];
        let arrayAnim = [];
        arreyAnim.forEach((flag, index) => {

            if (index == 0) arrayAnim[index] = this.config.modalChild(flag, flag, null, arreySeek);
            if (index == 1) arrayAnim[index] = this.config.modalChild(flag, flag, null, arreyBoin);
            if (index == 2) arrayAnim[index] = this.config.modalChild(flag, flag, null, arreyFain);
            if (index == 3) arrayAnim[index] = this.config.modalChild(flag, flag, null, arreyFlip);
            if (index == 4) arrayAnim[index] = this.config.modalChild(flag, flag, null, arreyLigh);
            if (index == 5) arrayAnim[index] = this.config.modalChild(flag, flag, null, arreyRoin);
            if (index == 6) arrayAnim[index] = this.config.modalChild(flag, flag, null, arreySlin);
            if (index == 7) arrayAnim[index] = this.config.modalChild(flag, flag, null, arreyZoin);
            if (index == 8) arrayAnim[index] = this.config.modalChild(flag, flag, null, arreySpec);

        });
        let fieldAnim = this.config.modalField(TFieldType.ftShaay, null, null, null, this.change.select, arrayAnim, null);
        let groupAnim = this.config.modalGroup(null, [fieldAnim]);

        //Procura por title para selecionar na tela
        let get = (array): any => array.find(item => (item.value == this.change.select));
        let line = get(arreySeek) || get(arreyBoin) || get(arreyFain) || get(arreyFlip) || get(arreyLigh) || get(arreyRoin) || get(arreySlin) || get(arreyZoin) || get(arreySpec);
        if (line) fieldAnim.anime = line.title;

        let slideAnim = this.config.modalSlide('Animate', null, null, null, 'CorRoxa', [groupAnim]);
        this.change.slides = [slideAnim];

    }

    debugTeste() {

        let onOkiy = (that, okiy, index, isLast) => that.dismiss();

        let items = [
            this.config.modalChild('#Pista', 0, 'b-icon-male'),
            this.config.modalChild('#Pista', 1, 'b-icon-male'),
            this.config.modalChild('#Pista', 2, 'b-icon-male'),
            this.config.modalChild('#Pista', 1000, 'b-icon-male')
        ];

        let limit = {min: 1, max: 1, pos: 0};
        let field = this.config.modalField(TFieldType.ftPutin, 'Teste', null, limit, '0,2', items);
        let group = this.config.modalGroup('Checkbox', [field]);
        let slide = this.config.modalSlide('Ambientes', 'Selecione', 'Até 4 ambientes', null, 'CorRoxa', [group]);

        this.util.modalopen(ModalFieldPage, 'quad', true, {slides: [slide], onOkiy: onOkiy}).subscribe();

    }

    debugText() {

        let colorList: any[] = [];
        for (let color in this.config.colors) colorList.push({title: color, value: color});

        this.infos = {
            slides: [{
                corcor: 'CorRoxa',
                header: 'Color Picker 2',
                groups: [{
                    fields: [{
                        type: TFieldType.ftColor,
                        title: 'Cor Exemplo',
                        value: 'CorVerm',
                        limit: {min: 0, max: 10, pos: 0},
                        texto: 'Teste de cores fixas.',
                        items: colorList
                    }]
                }]
            }, {
                corcor: 'CorVerm',
                header: 'Teste Topo',
                titulo: 'Título Teste',
                resumo: 'Uma pequena frase de resumo.',
                imagem: 'b-icon-ticket',
                groups: [{
                    titulo: 'Nome Grupo',
                    fields: [{
                        type: TFieldType.ftLine,
                        title: 'Nome Campo',
                        texto: 'Informações extras',
                        icone: 'b-icon-list',
                        limit: {min: 0, max: 10, pos: 0},
                        value: 'Valor padrão',
                        items: [{
                            title: 'Nome do Item',
                            value: 'Nome do Item',
                            icone: 'b-icon-home'
                        }],
                        options: {}
                    }, {
                        type: TFieldType.ftLine,
                        title: 'Nome 2',
                        texto: 'Informações',
                        icone: 'b-icon-home',
                        limit: {min: 0, max: 20, pos: 0},
                        value: 'Valor exemplo',
                        items: [{
                            title: 'Item', // apenas checkbox
                            value: 'Item', // id para checkbox ou valor em texto
                            icone: 'b-icon-alert'
                        }, {
                            title: 'Item 2', // apenas checkbox
                            value: 'Item 2', // id para checkbox ou valor em texto
                            icone: 'b-icon-ok'
                        }],
                        options: {}
                    }]
                }, {
                    titulo: 'Outros',
                    fields: [{
                        type: TFieldType.ftFone,
                        title: 'Telefone',
                        value: '',
                        limit: {min: 0, max: 15, pos: 0} // usado para calcular tamanho apenas
                    }, {
                        type: TFieldType.ftQtde,
                        title: 'Qtde',
                        value: '',
                        limit: {min: 0, max: 4, pos: 0}
                    }, {
                        type: TFieldType.ftReal,
                        title: 'Preço',
                        value: '',
                        limit: {min: 0, max: 3, pos: 0},
                        options: {decimal: 2}
                    }]
                }]
            }, {
                corcor: 'CorRoxa',
                header: 'Checkbox',
                groups: [{
                    fields: [{
                        type: TFieldType.ftPutin,
                        title: 'Letras',
                        texto: 'Selecione até 4 das opções que mais lhe agrada.',
                        limit: {min: 0, max: 4, pos: 0},
                        value: '5,12,25',
                        items: [
                            {title: 'A', value: 5, icone: 'b-icon-ticket'},
                            {title: 'B', value: 10, icone: 'b-icon-ticket'},
                            {title: 'C', value: 12, icone: 'b-icon-ticket'},
                            {title: 'D', value: 16, icone: 'b-icon-ticket'},
                            {title: 'E', value: 18, icone: 'b-icon-ticket'},
                            {title: 'F', value: 19, icone: 'b-icon-ticket'},
                            {title: 'G', value: 24, icone: 'b-icon-ticket'},
                            {title: 'H', value: 25, icone: 'b-icon-ticket'},
                        ]
                    }]
                }]
            }, {
                corcor: 'CorRoxa',
                header: 'Checkbox',
                groups: [{
                    fields: [{
                        type: TFieldType.ftRadio,
                        title: 'Gênero',
                        texto: 'Você não poderá alterar no futuro.',
                        value: '',
                        limit: {min: 0, max: 10, pos: 0},
                        items: [
                            {title: 'Masculino', value: 0, icone: 'b-icon-male'},
                            {title: 'Feminino', value: 1, icone: 'b-icon-female'},
                            {title: 'Outro', value: 2, icone: 'b-icon-circle'},
                        ]
                    }]
                }]
            }, {
                corcor: 'CorDark',
                header: 'Color Picker',
                groups: [{
                    fields: [{
                        type: TFieldType.ftPaint,
                        title: 'Cor Primária',
                        value: '#ff0000',
                        limit: {min: 0, max: 10, pos: 0},
                        texto: 'Utilizada em botões e links.'
                    }]
                }]
            }, {
                corcor: 'CorRoxa',
                header: 'Conteúdo',
                groups: [{
                    fields: [{
                        type: TFieldType.ftHtml,
                        title: 'Detalhes do evento',
                        limit: {min: 0, max: 10, pos: 0},
                        value: '<p>Teste de <b>contéudo</b></p>'
                    }]
                }]
            }, {
                corcor: 'CorRoxa',
                header: 'Data e Hora',
                groups: [{
                    fields: [
                        {type: TFieldType.ftData, limit: {min: 0, max: 10, pos: 0}, title: 'Data do evento', value: '2019-03-28'},
                        {type: TFieldType.ftHora, limit: {min: 0, max: 10, pos: 0}, title: 'Data da pós festa', value: ''}
                    ]
                }]
            }, {
                corcor: 'CorRoxa',
                header: 'Imagens',
                groups: [{
                    fields: [{
                        type: TFieldType.ftFile,
                        title: 'Foto Capa',
                        value: '',
                        limit: {min: 0, max: 10, pos: 0},
                        texto: 'JPEG ou PNG - 500x500px.',
                        options: {
                            acceptTypes: 'image/jpeg,image/png', width: 500, height: 500
                        }
                    }, {
                        type: TFieldType.ftFile,
                        title: 'Foto Fundo',
                        value: '',
                        limit: {min: 0, max: 10, pos: 0},
                        texto: 'JPEG ou PNG - 1920x1920px.',
                        options: {
                            acceptTypes: 'image/jpeg,image/png', width: 1920, height: 1920
                        }
                    }]
                }]
            }],

            onOkiy: () => {alert('ok')},
        };

        this.infos = {
            slides: [{
                corcor: 'CorRoxa',
                header: 'Color Picker 2',
                titulo: 'Color Picker 2',
                imagem: null,
                groups: [{
                    fields: [{
                        type: TFieldType.ftColor,
                        title: 'Cor Exemplo',
                        value: 'CorVerm',
                        limit: {min: 0, max: 10, pos: 0},
                        texto: 'Teste de cores fixas.',
                        items: colorList
                    }]
                }]
            }]
        };

        this.change = this.util.deepCopy(this.infos);

    }

    getIndex() {

        if (typeof this.slider.getActiveIndex() == 'undefined') return 0;
        return this.slider.getActiveIndex();

    }

    getTitle() {

        let index = this.getIndex();
        let resum = (this.infos.slides.length > 1 && this.infos.slides.length == this.getIndex());

        let result = (resum ? 'Resumo' : '');

        for (let i = index; i >= 0; i--) {
            if (!result) result = this.infos.slides[i].header;
        }

        return result

    }

    sliderMove(event?) {

        let index = this.getIndex();
        let resum = (this.change.slides.length > 1 && this.change.slides.length == this.getIndex());

        this.colorBack = (resum ? 'CorRoxa' : this.change.slides[index].corcor);

        if (!resum && this.change.slides[index].groups[0].fields[0].type == TFieldType.ftColor) {
            this.colorBack = this.change.slides[index].groups[0].fields[0].value || 'CorMilk';
        }

        let colorWhite = (this.config.negative(this.colorBack) == 'CorMilk');
        this.util.statusBarColor((colorWhite ? TStatusBar.sbStyleLightContent : TStatusBar.sbStyleDefault));

        setTimeout(() => this.content.resize());

    }

    iconimg(tipo?) {

        let index = this.getIndex();
        let resum = (this.change.slides.length == this.getIndex());
        let icon = (!resum && this.infos.slides[index].imagem && this.infos.slides[index].imagem.length && this.infos.slides[index].imagem.slice(0, 6) == 'b-icon');

        return (tipo == 'icon' && icon) || (tipo != 'icon' && !icon);

    }

    colorSelect(field: any, value) {

        field.value = value;
        this.sliderMove();

        this.action();
    }

    fileOpen(field: any, checkPlaying: boolean = false): boolean {

        let file = {GaleriaFile: field.value};
        return this.util.musicsee(file, checkPlaying);

    }

    fileTipo(field: any): TFileTipo {

        if (!field.value) return TFileTipo.ftTipos;

        let value = (field.value.base64 ? field.value.base64 : field.value);
        return this.util.fileTipo(this.util.fileType(value));

    }

    fileSource(field: any): string {

        return (field.value && field.value.base64 ? field.value.base64 : field.value);

    }

    fileSelect(field: any) {

        this.util.fileSelect(field.options).subscribe(
            base => {

                let copy = this.util.deepCopy(field);
                copy.value = base[0];

                //Validações
                this.process(copy)
                    .finally(() => {

                        if (copy.result) {
                            let erro = {Titulo: 'OPS!', Result: copy.result};
                            this.util.alertResult(erro);
                            return;
                        }

                        field.result = '';
                        field.value = base[0];

                    })
                    .subscribe();

            },

                erro => this.util.alertResult(erro)
        );

    }

    valueTitle(field) {
/*
        let values = field.value.split(',');

        let str = '';

        values.forEach((v, i) => {

            str += field.items.filter(i => i.value == v)[0].titulo + ((i+1 != values.length) ? ((i+2 == values.length) ? ' e ' : ', ') : '');

        });

        return str;
*/ //EXCLUIR - MIDUKAN, Essa rotina serve pra que estava dando pal e comentei.

        if (!field.items) return '';

        let result = '';
        field.items.forEach(item => {
            if (field.value == item.value) result = item.title;
        });

        return result;//'Midukan Ver...';
    }

    fieldClick(field, fieldIndex, groupIndex) {

        this.fieldObject = field;
        this.fieldSelect = fieldIndex;
        this.groupSelect = groupIndex;

        if (field.type == TFieldType.ftPicker) {

            let onSave = (qtde) => {
                field.value = qtde;
            };

            let buttons: Array<any> = [];
            field.items.forEach(item => buttons.push({text: item.title, value: item.value}));

            let columns = [];
            columns.push({name: 'root', options: buttons});
            columns[0].selectedIndex = 0;
            this.util.pickerOpen(columns, onSave);

        }

        if (field.type == TFieldType.ftSheet) {

            let arraytexto: Array<any> = [];
            let arrayvalue: Array<any> = [];

            field.items.forEach(item => {
                arraytexto.push(item.title);
                arrayvalue.push(item.value);
            });

            this.util.arrayStart(TChooseType.ctSheet, field.title, arrayvalue, arraytexto, 'value', field.value, this);

        }

    }

    sheetClick(field, fieldIndex, groupIndex, itemsIndex) {

        this.fieldObject = (field.type == TFieldType.ftSheey ? field.items[itemsIndex] : field);
        this.fieldSelect = fieldIndex;
        this.groupSelect = groupIndex;
        this.itensSelect = itemsIndex;

        let arraytexto: Array<any> = [];
        let arrayvalue: Array<any> = [];

        field.items[itemsIndex].items.forEach(item => {
            arraytexto.push(item.title);
            arrayvalue.push(item.value);
        });


        this.util.arrayStart(TChooseType.ctSheet, field.title, arrayvalue, arraytexto, 'value', field.value, this);

    }

    arrayClick(fieldname, selected, that, extra) {

        this.fieldObject.value = selected;

        if (this.change.window == 'Animate') {
            this.animecss = {animated: true};
            this.animecss[selected] = true;

            let arrayFind = this.fieldObject.items[this.itensSelect].items;
            this.fieldObject.value = selected;
            this.fieldObject.anime = arrayFind.find(item => (item.value == selected)).title;
        }

    }

    filterCheckbox(field, item): boolean {

        if (field.type != TFieldType.ftPutin || !field.value) return false;

        let achou = false;
        let array = (field.value + '').split(',');
        array.forEach(value => achou = (achou || value == item.value));

        return achou;

    }

    clickCheckbox(field, item) {

        if (field.type == TFieldType.ftPutin) {
            let values: any = (!field.value ? [] : (field.value + '').split(','));

            let value = typeof item.value == 'string' ? item.value : item.value.toString();
            let boool = this.filterCheckbox(field, item);
            let beeel = (!field.limit.max || field.limit.max > (field.value + '').split(',').length);

            //Insert
            if (!boool && beeel) values.push(item.value);

            //Delete
            if (boool) values.splice(values.indexOf(value), 1);

            values.sort();
            field.value = (!values.length ? '' : values.join(','));
            return;
        }

        field.value = item.value;

    }

    itemsAllow(field, fieldIndex, groupIndex) {

        let typeAllow = (field.type != TFieldType.ftSheet && field.type != TFieldType.ftShaay && field.type != TFieldType.ftSheey && field.type != TFieldType.ftRadio && field.type != TFieldType.ftColor);
        return (field.items && field.items.length && typeAllow && ((this.groupSelect == groupIndex && this.fieldSelect == fieldIndex) || field.type == TFieldType.ftPutin));

    }

    zipcityMenu(event, field) {

        let onCity = (city) => {
            if (!city) return;
            field.value = city.Zone + ' - ' + city.City;
            field.codigo = city.Pkey;
        };

        let loading = this.util.loadingDots();
        loading.present();

        this.webstorService.zipload(TAction.acLoad, TZiptipo.zpCity)
            .finally(() => loading.dismiss()).subscribe(
            data => onCity(data),
            erro => this.util.alertResult(erro, () => this.dismiss(false)));

    }

    start() {

        let root = this.change;

        //verifica
        root.slides.forEach((slide, sli) => {
            slide.groups.forEach((group, gro) => {
                group.fields.forEach((field, fie) => {

                    //ftReal
                    if (field.type == TFieldType.ftReal) {
                        if (typeof field.value == 'string') field.value = this.util.dinheiro(field.value);
                        field.value = this.util.dinheiro(field.value, !!(field.options || {}).decimal, true);
                    }

                });
            });
        });

    }

    onKeyup(field) {

        let trim = (field.options || {}).trim;
        if (trim) field.value = field.value.trim();

        let sensity = (field.options || {}).sensity;
        if (sensity == TUpperLowerCase.ulUpper) field.value = field.value.toUpperCase();
        if (sensity == TUpperLowerCase.ulLower) field.value = field.value.toLowerCase();

    }

    process(field: any): Observable<any> {

        return Observable.create(observer => {

            //Others - ftFile
            //let afile = [TFieldType.];
            //if (afile.indexOf(field.type) >= 0) field.value = (field.value || '');

            //String - ftHtml
            let array = [TFieldType.ftDoc, TFieldType.ftCpf, TFieldType.ftCnpj, TFieldType.ftDate, TFieldType.ftHour, TFieldType.ftLine, TFieldType.ftLink, TFieldType.ftHtml, TFieldType.ftMail, TFieldType.ftFone, TFieldType.ftPaint, TFieldType.ftColor];
            if (array.indexOf(field.type) >= 0) field.value = (field.value || '');

            //Number - ftReal
            let arrey = [TFieldType.ftQtde, TFieldType.ftReal];
            if (arrey.indexOf(field.type) >= 0) field.value = (field.value || 0);

            //Others - ftFile, ftCity, ftDate, ftHour, ftData, ftHora, ftSheet, ftRadio, ftCheck, ftPutin,
            //let arroy = [TFieldType.];
            //if (arroy.indexOf(field.type) >= 0) field.value = (field.value || 0);


            //ftFile - pngImage
            if (field.type == TFieldType.ftFile) {

                let minimg = field.limit.min && (!field.value);
                field.result = (!minimg) ? '' : 'Selecione o arquivo!';

                if (field.value && !field.result && field.options.acceptTypes == 'image/png') {
                    this.util.pngTransparent(field.value.base64)
                        .finally(() => observer.complete())
                        .subscribe(
                            data => field.result = '',
                            erro => field.result = 'PNG não é transparente!'
                        );
                }

            }

            //String
            if (array.indexOf(field.type) >= 0) {
                let minstr = field.limit.min && (field.value.length < field.limit.min);
                let maxstr = field.limit.max && (field.value.length > field.limit.max);
                field.result = (!minstr && !maxstr) ? '' : field.title + ' obrigatório!';
            }

            //Number
            if (arrey.indexOf(field.type) >= 0) {
                let minnum = field.limit.min && (field.value < field.limit.min);
                let maxnum = field.limit.max && (field.value > field.limit.max);
                field.result = (!minnum && !maxnum) ? '' : field.title + ' ' + (minnum ? (!field.value ? 'obrigatório!' : 'min ' + field.limit.min) : 'max ' + field.limit.max);
            }

            //ftDate
            if (field.type == TFieldType.ftDate) {
                let mindat = field.limit.min && (this.util.strToDate(field.value) < this.util.strToDate(field.limit.min));
                let maxdat = field.limit.max && (this.util.strToDate(field.value) < this.util.strToDate(field.limit.max));
                field.result = (!mindat && !maxdat) ? '' : field.title + ' ' + (field.value ? 'inválida!' : 'obrigatória!');
            }

            observer.complete();

        });

    }

    verify(page: number = -1): Observable<any> {

        return Observable.create(observer => {
            //.timer(2000,5000)

            let fail: any = null;
            let root = this.change;

            let totalLoad = 0;
            let countLoad = 0;

            //calcula
            root.slides.forEach((slide, sli) => {
                if ((page >= 0 && page != sli)) return;

                slide.groups.forEach((group, gro) => {

                    group.fields.forEach(() => countLoad++);

                });

            });

            //verifica
            root.slides.forEach((slide, sli) => {
                if ((page >= 0 && page != sli)) return;

                slide.groups.forEach((group, gro) => {
                    group.fields.forEach((field, fie) => {

                        this.process(field)
                            .finally(() => {

                                if (!fail && field.result) fail = {Titulo: slide.titulo, Result: field.result};

                                totalLoad++;
                                if (totalLoad == countLoad) {
                                    if (!fail) observer.next();
                                    if (fail) observer.error(fail);
                                    observer.complete();
                                }

                            })
                            .subscribe();

                    });
                });
            });

        });

    }

    action() {

        //Pronto - Resumo ou Ultimo sem Resumo
        if ((this.infos.slides.length == 1 || this.infos.slides.length == this.getIndex())) {

            // não perde a referência de memória mas os dados e sub objetos ficam todos renovados
            //this.util.populateObj(this.infos, this.change, ['onOkiy']);

            //Validações
            this.verify().subscribe(
                data => this.infos.onOkiy(this, this.change.slides, this.getIndex(), true),
                erro => this.util.alertResult(erro)
            );

            return;
        }


        //Page Next - Validações
        this.verify(this.getIndex()).subscribe(
            data => this.infos.onOkiy(this, this.change.slides, this.getIndex(), false),
            erro => this.util.alertResult(erro)
        );

    }

    slideNext() {

        //Trava Slide lateral
        this.slider.lockSwipes(false);
        if (this.corrigindo) {
            this.slider.slideTo(this.slider.length() - 1);
            this.corrigindo = false;
        } else {
            this.slider.slideNext();
        }
        this.slider.lockSwipes(true);

    }

    slideHeader(pos: 'NEXT' | 'BACK', index): boolean {
        return (index == 0 || this.util.arrayLoop(pos, this.change.slides, index, 'header', true));
        //return (this.change.slides[index].header && (index == 0 || this.change.slides[index].header != this.change.slides[index-1].header));

    }

    corrigir(index) {

        this.slider.lockSwipes(false);
        this.slider.slideTo(index);
        this.slider.lockSwipes(true);

        this.corrigindo = true;

    }

    isInputType(field) {

        return (field.type == TFieldType.ftDate || field.type == TFieldType.ftHour || field.type == TFieldType.ftHora || field.type == TFieldType.ftLine || field.type == TFieldType.ftLink || field.type == TFieldType.ftMail || field.type == TFieldType.ftCity || field.type == TFieldType.ftQtde || field.type == TFieldType.ftReal || field.type == TFieldType.ftFone);

    }

    isInputText(field) {

        return (field.type == TFieldType.ftDate || field.type == TFieldType.ftHour || field.type == TFieldType.ftLine || field.type == TFieldType.ftLink || field.type == TFieldType.ftCity || field.type == TFieldType.ftFone);

    }

    dismiss(back?) {

        //Volta slide anterior
        if (back && this.getIndex()) {
            this.slider.lockSwipes(false);
            this.slider.slidePrev();
            this.slider.lockSwipes(true);
            return;
        }

        if (this.viewCtrl.isOverlay) {
            this.viewCtrl.dismiss();
            return;
        }

        this.navCtrl.pop();

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/modal-field/modal-field.ts